<template>
  <div class="news-container">
    <!-- <page-top></page-top> -->
    <div class="content_wrap">
      <myImg
        img="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner_6.png"
      ></myImg>
      <my-tab
        :tab-list="tabList"
        @change="changeTab"
        :activeIndex="activeIndex"
        :bread-title="breadTitle"
        smallSize
      >
      </my-tab>
      <div class="news_list_box container" v-if="activeIndex == 1 && showList">
        <b-container>
          <b-row>
            <b-col
              md="6"
              lg="4"
              v-for="(v, i) in newsList"
              :key="i"
              @click="checkDetail(i)"
            >
              <div class="news_list_box_item mt-40">
                <div class="img_mask">
                  <div>
                    <i class="el-icon-search"></i>
                  </div>
                  <img
                    :src="v.img"
                    class="item_img"
                    height="230px"
                    :alt="v.alt"
                  />
                </div>

                <div class="mt-20 color-fff fs-20">{{ v.title }}</div>
                <span>{{ v.date }}</span>
              </div>
            </b-col>
          </b-row>
        </b-container>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="10"
          @@pagination="_getList"
        ></el-pagination>
      </div>
      <template v-if="activeIndex == 2">
        <div class="fs-24 mt-40 mb-40">暂无相关内容</div>
        <!-- <h2 class="fs-24 mt-40 mb-40">
					第十九届广州国际汽车展览会疫情防控指引
				</h2>
				<div class="container fs-20">
					<div class="mb-30">尊敬的各参展商、各媒体以及其他与会工作人员：</div>
					<div class="text-in mb-20">
						为做好本届展会的疫情防控工作，根据广州市展览活动疫情防
						控工作相关指引，所有与会人员务必落实身份必录、绿码必查、体
						温必测、口罩必戴、消毒必做、突发必处的“六必原则”。现将本
						届展会的相关工作要求通知如下：
					</div>
					<div class="text-in mb-20">
						<span class="bold">一、严格执行实名制。</span>由布展、开展，到撤展全过程，所有与
						会人员都必须信息建档（见附件），按人员常住地区进行区分汇总。
					</div>
					<div class="text-in mb-20">
						<span class="bold">二、展前开展排查工作。</span>针对来自中、高风险区人员，10 月 25
						日起有发生疫情的城市旅居史的人员，遵循以下原则：
					</div>
					<div class="text-in mb-20">
						不接受来自中、高风险地区或 14 天内有中高风险区旅居史的
						人员入场【中、高风险区，及 10 月 25 日起有发生疫情但风险等级还
						没提高的城市，以县、县级市（副省级城市、省级市以区）为单位】。
					</div>
					<div class="text-in mb-20">
						该城市（地级市或副省级城市、省级市）其他地区人员进馆前， 须提供 48
						小时内的在穗核酸检测阴性证明，进入展馆后实行核酸
						“一天一检”，在穗期间实行相对闭环管理，限定活动场所为从展
						馆到居住酒店“两点一线”，并主动向主办单位报备其在穗行程。
					</div>
					<div class="text-in mb-20">
						（示例：北京市昌平区现有高风险地区 1 个、中风险地区 2 个，故昌平
						区人员原则上不接受入场；其他区人员进馆前，须提供 48 小时内在穗核酸 1
						检测阴性证明，进入展馆后实行核酸 “一天一检”
					</div>
					<div class="text-in mb-20">
						<span class="bold">三、实行自我健康监测。</span>所有与会人员于参会前
						14 天每日做 好自我健康监测；行程卡 14
						天内含有广东省以外旅居史的参会人 员，进馆时须持有 48
						小时内核酸检测阴性证明。
					</div>
					<div class="text-in mb-20">
						<span class="bold">四、持健康码入场。</span>所有与会人员必须持有粤康码、穗康码其
						中之一，健康码为绿码者可以进场，禁止持黄（红）码者入场。
					</div>
					<div class="text-in mb-20">
						<span class="bold">五、主动配合测温验码。</span>不允许出现任何单位或人员抵触或不
						配合测温验码，否则广州市展览督导组将协调取消该单位或人员进
						入本次展会的资格。
					</div>
					<div class="text-in mb-20">
						<span class="bold">六、规范佩戴口罩。</span>所有与会人员须佩戴好一次性使用医用口
						罩，并保持在馆内全程佩戴不得脱下。如口罩污损，须及时更换。
						广州市展览督导组将在展馆内不间断巡查期间，对不规范佩戴口罩
						人员将进行提醒，对拒不改正的人员将要求其离场。
					</div>
					<div class="text-in mb-20">
						<span class="bold">七、严格执行清洁消杀制度。</span>展前须对展位和展品进行全面清 洁洗消，每天至少 1
						次消毒，及时清运垃圾，确保无卫生死角，并 做好台账记录
					</div>
					<div class="text-in mb-20">
						<span class="bold">八、快速有效处置突发情况。</span>各展台须储备必要的药物和防疫
						物资，并安排专人负责处理现场发热、咳嗽及其他症状人员。对身
						体感到不适的工作人员应提前劝阻其进入展馆；当与会的人员的常
						住地（县区级行政区）出现疫情时，立即停止其所有参会活动并注
						销证件；出现突发情况时应立即报主办单位并将相关人员送至现场
						医疗点，同时配合做好人员转运、消毒、隔离等应急措施并全程跟踪
					</div>
					<div class="text-in mb-20">
						展馆现场医疗点信息：
					</div>
					<div class="text-in mb-20">
						A 区：珠江散步道 4 号馆 1 号柜台，电话：020-89130120；
					</div>
					<div class="text-in mb-20">
						B 区：珠江散步道 9 号馆 4 号柜台，电话：020-89124120；
					</div>
					<div class="text-in mb-20">
						<span class="bold">九、展会现场设置核酸检测点。</span>具体安排如下：
					</div>
					<div class="text-in mb-20">
						地点：A 区 Y 通道 2.1 号馆旁
					</div>
					<div class="text-in mb-20">
						开放时间：11 月 9 日-11 月 30 日，每天 9:30-17:30
					</div>
					<div class=" mb-40">（首次抵穗在机场、车站、码头等进行核酸检测者，可凭此 48 小
						时内的核酸阴性证明进馆，后期可在展会现场检测点进行检测。）
					</div>
					<a class="download"
						href="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/gzcz_fk.xlsx">附件：参会人员健康信息统计表</a>
					<div class="mt-60 text-right">广州汽车展组委会</div>
					<div class="mb-40 text-right">2021 年 11 月 6 日</div> 
				</div> -->
      </template>
      <div class="news_notice container" v-if="activeIndex == 0 && showList">
        <!-- <h2>暂无相关内容</h2> -->
        <b-container>
          <b-row>
            <b-col
              md="6"
              lg="4"
              v-for="(v, i) in noticeList"
              :key="i"
              @click="checkDetail(i)"
            >
              <div class="news_list_box_item mt-40" v-if="i < 9">
                <div class="img_mask">
                  <div>
                    <i class="el-icon-search"></i>
                  </div>
                  <img
                    :src="v.img"
                    class="item_img"
                    height="230px"
                    :alt="v.alt"
                  />
                </div>

                <div class="mt-20 color-fff fs-20">{{ v.title }}</div>
                <span>{{ v.date }}</span>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="detail_wrap container" v-if="detailFlag">
        <div
          v-html="
            activeIndex == 1
              ? newsList[curIndex].detail
              : noticeList[curIndex].detail
          "
        ></div>
      </div>
    </div>
    <!-- <page-bottom></page-bottom> -->
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageTop from "@/components/pageTop";
// import pageBottom from "@/components/pageBottom";
import myTab from "@/components/myTab";
import myImg from "@/components/myImg";
import pageFooter from "@/components/pageFooter";
import merge from "webpack-merge";
export default {
  components: {
    pageTop,
    myImg,
    // pageBottom,
    myTab,
    pageFooter,
  },
  mounted() {
    this.changeTabs(this.tabs);
    // this.changeCurs(this.curs);
  },
  data() {
    return {
      tabList: [
      {
          title: "展会公告",
          en: "Notice",
        },
        {
          title: "展会新闻",
          en: "News",
        }
      ],
      breadTitle: {
        cn: "新闻中心",
        en: "News Center",
      },
      tabs: this.$route.query.tab,
      curs: this.$route.query.cur,
      newsId: this.$route.query.newsId ? this.$route.query.newsId : "",
      noticeId: this.$route.query.noticeId ? this.$route.query.noticeId : "",
      activeIndex: 0,
      detailFlag: false,
      showList: true,
      curIndex: undefined,
      noticeList: [
      {
          id:9,
          title:'第二十一届广州国际汽车展览会媒体注册通知',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner4.jpg",
          date:'2023-11-02',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/20.png' alt/>`
      },
      {
          id: 8,
          title: "第二十一届广州国际汽车展览会时间安排",
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner4.jpg",
          date: "2023-09-12",
          detail: `<h2 class="media_font_size_70">第二十一届广州国际汽车展览会时间安排</h2><span class="detail_date media_font_size_30">发布时间：2023-09-12</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>第二十一届广州国际汽车展览会将于2023年11月17日至26日在中国进出口商品交易会展馆举办，11月17日为媒体日。汽车零部件及用品展区（智能网联、定制改装、汽车生活）展览时间为11月17日至20日，欢迎全球观众、媒体及业内人士前来参观。</span>`,
        },
        {
          id: 7,
          title: "关于恢复举办2022第二十届广州国际汽车展览会的通知",
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_7/22_12.jpg",
          date: "2022-12-13",
          detail: `<h2 class="media_font_size_70">关于恢复举办2022第二十届广州国际汽车展览会的通知</h2><span class="detail_date media_font_size_30">发布时间：2022-12-13</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>尊敬的各参展商、各合作单位及各界观众：</span><span class='detail_desc media_line_height_50 media_font_size_50'>为了促进经济平稳运行，提振行业信心，刺激 消费，加快推动复工复产，在提高服务质量、完善 保障措施、细化多场景下应急方案的前提下，主办 方决定恢复举办“2022第二十届广州国际汽车展览会”，举办时间为2022年12月30日至2023年1月8
日。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>衷心感谢各参展商、各合作单位和社会各界人
土长期以来对广州国际汽车展览会的支持和关注！</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>特此通知。</span><span class='detail_desc media_line_height_50 media_font_size_50 text_right'>广州国际汽车展览会组委会</span>
<span class='detail_desc media_line_height_50 media_font_size_50 text_right'> 2022年12月13日</span>`,
        },
        {
          id: 6,
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_6/22_03.jpeg",
          title: "关于2022第二十届广州国际汽车展览会延期举办的通知",
          date: "2022-11-04",
          detail: `<h2 class="media_font_size_70">关于2022第二十届广州国际汽车展览会延期举办的通知</h2><span class="detail_date media_font_size_30">发布时间：2022-11-04</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>尊敬的各参展商、各合作单位及各界观众：
</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>我们将密切关注疫情发展，根据疫情防控政策要求，竭力做好展会的各项组织和服务工作。延期后的具体举办时间将另行通知。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>衷心感谢各参展商、各合作单位和社会各界人士长期以来对广州国际汽车展览会的支持和关注！</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>特此通知。</span>
<span class='detail_desc media_line_height_50 media_font_size_50 text_right'>广州国际汽车展览会组委会</span>
<span class='detail_desc media_line_height_50 media_font_size_50 text_right'> 2022年11月4日</span>
<h2 class="media_font_size_70">Notice on the Postponement of AUTO GUANGZHOU 2022</h2>
<span class='detail_desc media_line_height_50 media_font_size_50'>Dear exhibitors, partners and visitors,</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>Widespread and frequent occurrence of COVID-19 pandemic in many parts of Guangzhou has posed severe challenge for the city’s epidemic prevention and control. In order to fully cooperate with and implement the epidemic prevention and control requirements of the state and the Guangzhou municipal government, effectively ensure exhibitors’ physical health and public health safety as well as good exhibition results, we, the Organizing Committee of AUTO GUANGZHOU 2022, have decided to postpone the auto show which was initially planned in November 18-27 this year.</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>We will pay close attention to the development of the epidemic, and strive to enhance the event’s organization and service work according to the requirements of the epidemic prevention and control policy. The specific holding time after the extension will be notified separately.</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>We deeply appreciate the exhibitors, partners and people from all walks of life for their long-term support to the AUTO GUANGZHOU!</span>
<span class='detail_desc media_line_height_50 media_font_size_50 text_right'>Organizing Committee of AUTO GUANGZHOU</span>
<span class='detail_desc media_line_height_50 media_font_size_50 text_right'> November 4，2022</span>`,
        },
        {
          id: 5,
          img: require("../../assets/img/banner1.png"),
          title: "疫情防控调整提醒",
          date: "2021-11-23",
          detail: `<h2 class="media_font_size_70">疫情防控调整提醒</h2><span class="detail_date media_font_size_30">发布时间：2021-11-23</span>
          <span class='detail_desc media_line_height_50 media_font_size_50'>为进一步做好本届展会的疫情防控工作，现根据广州市展览活动疫情防控工作相关指引，将本届展会疫情防控相关工作调整如下：</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>一、严格执行实名制。原则上不接受来自中、高风险地区或14天内有中高风险区旅居史的人员入场。（当前中高风险地区：北京市海淀区、朝阳区、上海市、大连市、云南德宏州、上饶市、兰州市、阿拉善盟、辛集市、成都市、重庆沙坪坝区、吉林市、黑河市、郑州市、周口市。）</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>另，11月19日以来有江苏苏州、21日以来有江苏徐州、22日以来有浙江杭州旅居史人员不接受进入展会。（包括11月17-18日参加过在上海举办的“2021首届中国国际财税博览会暨第四届FLF中国财税领袖前沿峰会”的人员。）</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>二、严格实行健康监测。行程卡14天内含有广州市以外旅居史的参会人员，进馆时须持有48小时内在粤核酸检测阴性证明。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>三、持健康码入场。所有与会人员必须持有粤康码、穗康码其中之一。健康码为绿码者可以进场，禁止持黄（红）码者入场。无法将核酸检测结果同步到健康码的外籍和港澳台人士，须持有48小时内在穗核酸检测阴性证明电子版或纸质报告</span>
<span class='detail_desc media_line_height_50 media_font_size_50'> 四、主动配合测温验码。所有与会人员须主动配合测温验码，如有抵触或不配合测温验码者，将取消该人员进入本次展会的资格。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>五、规范佩戴口罩。所有与会人员须全程佩戴好一次性使用医用口罩，如口罩污损，须及时更换。主办方将对不规范佩戴口罩人员将进行提醒，对拒不改正的人员将要求其离场。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>六、展馆现场医疗点信息：</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>A区：珠江散步道4号馆1号柜台，电话：020-89130120</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>B区：珠江散步道9号馆4号柜台，电话：020-89124120</span>
<span class='detail_desc media_line_height_50 media_font_size_50 text_right'>广州汽车展组委会</span>
<span class='detail_desc media_line_height_50 media_font_size_50 text_right'> 2021年11月23日</span>`,
        },
        {
          id: 4,
          img: require("../../assets/img/banner1.png"),
          title: "澄清说明",
          date: "2021-11-19",
          detail: `<h2 class="media_font_size_70">澄 清 声 明</h2><span class="detail_date media_font_size_30">发布时间：2021-11-19</span>
          <span class='detail_desc media_line_height_50 media_font_size_50'>致：广大社会公众及新闻媒体</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>我司昨日接到媒体举报发现，以北京爱票科技有限公司为微信账号主体设立的微信号：GuangzhouAuto名称为“广州车展”的微信公众号，发布我司举办的“第十九届广州国际汽车展览会”相关信息及售卖车展专业日、公众日及媒体日三类门票的信息和相关售票链接内容。为此，我司紧急向广大社会公众及新闻媒体发布声明：</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>一、我司从未授权该公司通过任何渠道售卖“第十九届广州国际汽车展览会车展”门票（含专业日、媒体日门票·通行卡），亦从未以任何方式售卖过媒体日门票或媒体日通行卡。该公司网站及微信公众号均属无权销售车展门票，该公众号售卖媒体日门票属非法倒卖行为。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>二、我司强烈谴责上列公司的侵权行为和非法倒卖车展门票的违法犯罪行为，并坚决追究其法律责任。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>三、敬请广大公众及各大新闻媒体不要被该侵权公众号误导，勿转发、报道上述侵权相关信息内容，以免误导公众构成侵权，从而承担侵权法律责任。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>四、请各大新闻媒体在广州国际汽车展览会官方网站及官方微信公众号收集车展信息，勿再引用、转载其他非官方渠道的不实信息和侵权内容。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>感谢广大公众和新闻媒体一直以来对“广州国际汽车展览会”的信赖和支持；欢迎举报一切对“广州国际汽车展览会”构成侵权和违法的行为！</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>特此声明！</span>
<span class='detail_desc media_line_height_50 media_font_size_50 text_right'>广州国际汽车展览会组委会</span>
<span class='detail_desc media_line_height_50 media_font_size_50 text_right'> 2021年11月19日</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>广州国际汽车展览会</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>官方网站：www.autoguangzhou.com.cn</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>￼官方微信：广州国际汽车展/auto_guangzhou</span>
<img  src="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/notice/pub.png"/ style="width:200px;"> `,
        },
        {
          id: 1,
          img: require("../../assets/img/banner1.png"),
          title: "遗失声明",
          date: "2021-11-18",
          detail: `<h2 class="media_font_size_70">遗失声明</h2><span class="detail_date media_font_size_30">发布时间：2021-11-18</span>
          <span class='detail_desc media_line_height_50 media_font_size_50'>兹我司举办的“第十九届广州国际汽车展览会”参展商，不慎遗失我司赠送如下门票及入场通行卡：</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>1、面值100元车展门票【流水码为：PA224031-PA224430】；</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2、面值50元车展门票【为：PB326801-PB326900】；</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>3、入场通行卡A【流水码为：ZA624601-ZA625200】；</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>4、入场通行卡B【流水码为：ZB811401-812000;ZB800335-800801；ZB811401-812000】；</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>现我司作为“第十九届广州国际汽车展览会”承办单位就上述门票、通行卡遗失声明：失效、作废。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>敬告广大消费者到我司授权的代理商购买合法有效门票，切勿向私人或无授权机构购买上述流水码门票和通行卡，以免造成损失；如有拾得该遗失门票、通行卡，请交还我司作废票处理！</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>特此声明！</span>
<span class='detail_desc media_line_height_50 media_font_size_50 text_right'>广州展联展览服务有限公司</span>
<span class='detail_desc media_line_height_50 media_font_size_50 text_right'> 2021年11月19日</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>本声明将通过我司官方网站、代理商网站、微信公众号、售票点及国内报刊向广大消费者公布，敬请留意。</span>`,
        },
        {
          id: 2,
          img: require("../../assets/img/banner1.png"),
          title: "第十九届广州国际汽车展览会公告",
          date: "2020-06-19",
          detail: `<h2 class="media_font_size_70">第十九届广州国际汽车展览会时间安排</h2><span class="detail_date media_font_size_30">发布时间：2020-11-29</span>
          <span class='detail_desc media_line_height_50 media_font_size_50'>第十九届广州国际汽车展览会将于2021年11月19日至28日在中国进出口商品交易会展馆举办，11月19日为媒体日。汽车零部件、改装车、新能源、新科技展区展览时间为11月19日至22日，欢迎全球观众、媒体及业内人士前来参观。</span>`,
        },
        {
          id: 3,
          img: require("../../assets/img/banner1.png"),
          title: "第十九届广州国际汽车展即将盛大开幕",
          date: "2021-11-09",
          detail: `<h2 class="text-center">第十九届广州国际汽车展览会时间安排</h2><span class="detail_date media_font_size_30">发布时间：2021-11-09</span>
          <div class='text-in fs-20'>过去的2020年，对于全球汽车行业是极其特殊的一年，对于中国汽车行业更是极具意义的一年。在世界汽车工业几近停摆的危机下，中国汽车产业展现出了强大的韧性，以顽强的生命力突出重围。2021年，是“十四五”开局之年，《“十四五”规划和二〇三五年远景目标建议》描绘了我国国民经济未来发展的美好蓝图，《新能源汽车产业发展规划（2021—2035年）》也为我们指明了新的方向和目标。随着以智能化为特征的第四次工业革命的深入推进，汽车智能网联化已经从概念进入到了全面应用的阶段，智能网联技术在向用户端和生产端双向同步发展。智能网联汽车正在告别发展的初级阶段，全面进入高质量发展新阶段，全球汽车产业将迎来深度变革的新机遇。</div>
          <img  src="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/gzcz_198231.webp"/> 
          <div class='text-in fs-20'>广州国际汽车展将紧跟产业发展新方向，贴合市场发展新需求，服务汽车行业，为全球汽车企业打造高品质、国际化、综合性的展览体验平台，与中外汽车企业携手共进，向业界展示最新车辆技术及科技成果</div>
          <h3 class="text-center fs-24 lh-60 ">第十九届广州国际汽车展情况介绍</h3>
          <div class="text-in fs-20">第十九届广州国际汽车展览会（以下简称“广州汽车展”）将于2021年11月19日至28日在中国进出口商品交易会展馆（以下简称“广交会展馆”）举办，其中汽车零部件及用品、汽车改装、新能源、新技术等题材展区的展期为11月19日至22日。11月19日为媒体日，仅对国内外媒体及特邀嘉宾开放。11月20日至21日为专业观众日，门票为100元；11月22日至28日为公众日，门票为50元。根据政府防疫相关部门的要求，本届展会将继续使用实名制认证，刷身份证入场的方式。观众通过“广州国际汽车展”官方微信可以一次性完成门票购买、门票激活及实名认证。</div>
          <div class="text-in fs-20">本届广州汽车展共使用广交会展馆A区全部13个展厅及B区3个展厅，以及A区南北广场室外展区，展会规模达22万平方米。本届广州汽车展上共有全球首发车54台，跨国公司首发车7台；概念车28台，其中国际品牌展车9台；国内外参展车企共展出新能源车241台，其中国外品牌展车88台。展车总数达1020台。媒体日当天将举办91场新闻发布会。</div>
          <img  src="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/gzcz_198232.webp"/> 
          <h3 class="text-center fs-24 lh-60">乘用车企业继续高规格参展</h3>
          <div class="text-in fs-20">在中国经济持续发展和国外疫情持续爆发的双重影响下，中国汽车市场已然成为全球车企的必争之地。本届广州汽车展上，乘用车品牌将继续以全品牌、高规格参展。包括宝马&MINI、梅赛德斯-奔驰及腾势、大众汽车品牌（一汽-大众、大众进口汽车、上汽大众）、一汽-大众奥迪、一汽-大众捷达、东风标致、东风雪铁龙、长安福特、林肯、上汽通用（别克、雪佛兰、凯迪拉克）、沃尔沃、捷豹路虎、一汽丰田、广汽丰田、雷克萨斯、东风本田、广汽本田、广汽讴歌、东风日产、东风启辰、东风英菲尼迪、长安马自达、广汽三菱、斯巴鲁、广汽菲克、现代及北京现代、起亚及东风悦达起亚、Polestar 极星、江铃等国际主流汽车品牌将集中亮相，上汽奥迪、江铃福特、捷尼赛思将首次登陆广州汽车展。</div>
          <div class="text-in fs-20">各集团均携全系列产品大规模参加本届车展，一汽红旗、东风风行、风光、上汽荣威、上汽名爵、上汽大通、长安汽车、欧尚汽车、北汽集团、广汽传祺均将在广州亮相。吉利、哈弗、奇瑞、比亚迪、领克、WEY、坦克、长城炮、JAC江汽集团、捷途等企业也将携自己的重磅产品登上广州汽车展的舞台，坦克品牌将首次在广州汽车展登场亮相。</div>
          <div class="text-in fs-20">蔚来、小鹏、理想、零跑、高合HiPhi、赛力斯、威马、飞凡汽车、广汽埃安、欧拉、奇瑞新能源、几何汽车、合创等新能源汽车品牌也将同场竞技，让观众更集中、更方便地参观体验最新的新能源汽车产品。岚图、智己汽车、ARCFOX 极狐、极氪、沙龙、合众等品牌均将首次登上广州汽车展展台与观众见面。</div>
          <div class="text-in fs-20"> 与此同时，众多豪华车品牌也都将登上广州汽车展的展台。包括保时捷、兰博基尼、宾利、劳斯莱斯、阿斯顿·马丁、路特斯等欧美顶级豪华品牌集中高规格展出，布加迪将首次亮相广州汽车展展会现场。此外，还有众多豪华改装车、高端商务改装及房车也将在广州汽车展精彩登场。</div>
          <h3 class="text-center fs-24 lh-60">创新题材为展会注入新动能</h3>
          <div class="text-in fs-20">随着中国汽车产业转型升级的不断推进，电动化、智能化、网联化趋势的持续加强，传统汽车产业链上游下游都面临着新的挑战。在产业链上游，数据处理、车网互联、智能设备等服务和产品提供商，成为了新的入局者；在下游的汽车后市场，主流的市场正在从传统的修车、养车向改车、玩车转变。基于产业和市场的双重变化，广州汽车展秉承“新科技、新生活”的主题理念，开设全新的题材展区。在广交会展馆10.2馆开辟“未来汽车科技馆”，集中展示以人工智能、自动驾驶、5G技术为代表的未来汽车科技；在9.2馆开辟“汽车改装文化生活馆”，打造以汽车改装、自驾露营、文化街区为主题的场景式展示新模式；11.2馆则将聚焦新能源汽车产业，以展示新能源汽车配套创新产品为核心，向业界呈现完整的新能源汽车全产业链。</div>
          <h3 class="text-center fs-24 lh-60">同期活动精彩纷呈</h3>
          <div class="text-in fs-20">广州汽车展期间将举办众多论坛、技术交流会等行业活动，剖析技术发展趋势与产品动态变化，汇聚产业资源、促进技术交流、推动商业合作，助力汽车产业高质量发展。</div>
          <div class="text-in fs-20">在公众活动方面，本届广州汽车展将创新打造全新的大型综合性同期活动——“广州国际汽车展科技文化艺术周”。秉承“新科技，新生活”的主题理念，活动期间将举办“广州国际汽车设计沙龙”、“广州国际汽车摄影文化节”、“广州国际汽车音乐节”、“广州车展美食文化节” “美人鱼水下时尚秀”等多元化的主题活动。活动现场还将设置“汽车潮流文化街区”、“科技文化创新集市”、“官改潮车大拍卖”、“国潮电竞游戏厅”等与汽车潮流文化深度结合的互动体验区，为广大车友打造玩乐新阵地。</div>
          <div class="text-in fs-20">本届展会的一个特殊亮点，是将集前沿科技之大成的无人驾驶动态体验带到了展会现场。组委会联合如祺出行与文远知行，在广交会展馆内的展场中路，打造了一个环形自动驾驶动态体验区，该体验区将面向公众开放，现场观众可以在广州汽车展现场乘坐无人无人驾驶车辆，亲身体验科技潮流新生活。</div>
          <h3 class="text-center fs-24 lh-60">坚决做好疫情防控工作</h3>
          <div class="text-in fs-20">广州汽车展主、承办单位高度重视疫情防控工作，全体工作人员深入学习领会习近平总书记关于疫情防控的重要讲话和指示批示精神，坚决贯彻落实党中央、国务院决策部署和省、市两级政府工作要求，把疫情防控作为广州汽车展项目工作的重中之重来抓，落实“四早”要求，坚持预防为主、分类指导、快速响应、落实责任的防控原则，切实做好疫情防控工作。在展会的前中后期，联合政府相关管理部门、展馆方定期召开展会疫情防控联席会议，密切关注疫情发展，并根据疫情发展动态调整和更新展会疫情防控工作方案，细化各项防控措施，通过实名制认证，从数据源头做到精准防控，保障每一位进场人员的生命安全，确保展会顺利举办。</div>
          <div class="text-in fs-20">  广州国际汽车展自2003年创办以来，始终与全球汽车产业同风雨、共进退。在将近二十年的时间里，广州汽车展始终以服务汽车行业为己任，致力于为全球汽车企业打造高品质、国际化、综合性的展览体验平台，为汽车行业国际交流与合作做出不懈的努力和应有的贡献。2021年11月19日至28日，第十九届广州国际汽车展览会将在中国进出口商品交易会展馆盛大举办。本届展会将继续秉承“新科技、新生活”的主题理念，向国际社会传递绿色科技新理念，与全球业界携手打造美好潮流新生活。</div>

          `,
        },
      ],
      newsList: [
      {
          id:33,
          title:'2023广州车展圆满闭幕，第二十二届将于2024年11月15日至24日举办',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c28.jpeg",
          date:'2023-11-26',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/28.png' alt/>`
        },
      {
          id:32,
          title:'第二十一届广州国际汽车展览会即将盛大开幕',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c27.jpeg",
          date:'2023-11-03',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/27.png' alt/>`
        },
      {
          id:31,
          title:'广州车展幸运大奖：遥遥领先！',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c26.jpeg",
          date:'2023-11-03',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/26.png' alt/>`
        },
      {
          id:30,
          title:'新科技·新生活 | 广汽丰田发动机携最新智造产品亮相广州车展20.1馆',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c25.png",
          date:'2023-11-02',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/25.png' alt/>`
        },
      {
          id:29,
          title:'新科技·新生活 | 松下EV压缩机即将亮相广州车展',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c24.jpeg",
          date:'2023-11-02',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/24.png' alt/>`
        },
      {
          id:28,
          title:'新科技·新生活 | 中航光电将携全新智能网联系列解决方案亮相广州车展',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c23.png",
          date:'2023-11-02',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/23.png' alt/>`
        },
      {
          id:27,
          title:'新科技·新生活 | 芯聚能半导体携最新模块产品亮相广州车展',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c22.jpeg",
          date:'2023-11-02',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/22.png' alt/>`
        },
      {
          id:26,
          title:'新科技·新生活 | YUTAKA(丰技研)集团携新产品亮相2023年广州车展',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c21.png",
          date:'2023-11-02',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/21.png' alt/>`
        },
        {
          id:24,
          title:'广州汽车展圆满闭幕，第二十一届将于11月17日至26日举办',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c7.jpg",
          date:'2023-01-08',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/19.png' alt/>`
        },
        {
          id:23,
          title:'2023智能网联汽车驾驶大赛（广州）正式启动',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c9.png",
          date:'2023-01-05',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/18.png' alt/>`
        },
        {
          id:22,
          title:'广州车展新年惊喜，元旦门票买一送一',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c7.jpg",
          date:'2023-01-01',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/17.png' alt/>`
        },
        {
          id:20,
          title:'第二十届广州国际车展展位图来啦',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c6.jpg",
          date:'2022-12-27',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/16.png' alt/>`
        },
        {
          id:21,
          title:'第二十届广州国际汽车展览会媒体现场注册及领证须知',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_7/22_12.jpg",
          date:'2022-12-27',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/15.png' alt/>`
        },
        {
          id:6,
          title:'云中锦书之五 | 寄语广州国际车展二十周年',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_7/22_12.jpg",
          date:'2022-12-26',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/1.png' alt/>`
        },
        {
          id:7,
          title:'广州车展幸运大抽奖——华为Mate手机天天送！',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c2.jpg",
          date:'2022-12-26',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/2.png' alt/>`
        },
        {
          id:8,
          title:'关于延长广州国际车展线上媒体注册时间的通知',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_7/22_12.jpg",
          date:'2022-12-26',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/3.png' alt/>`
        },
        {
          id:9,
          title:'云中锦书之四 | 寄语广州国际车展二十周年',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_7/22_12.jpg",
          date:'2022-12-25',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/4.png' alt/>`
        },
         {
          id:10,
          title:'第二十届广州国际车展可以买票啦！',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_7/22_12.jpg",
          date:'2022-12-25',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/5.png' alt/>`
        },
        {
          id:11,
          title:'合创汽车全新中大型纯电MPV即将于广州车展亮相',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c3.jpg",
          date:'2022-12-20',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/6.png' alt/>`
        },
        {
          id:12,
          title:'“广州汽车工业与广州国际车展20年”主题征文比赛优秀作品选登',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_7/22_12.jpg",
          date:'2022-12-20',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/7.png' alt/>`
        },
        {
          id:13,
          title:'“公路文化摄影展”获奖作品公布啦！！！',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c5.jpg",
          date:'2022-12-20',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/8.png' alt/>`
        },
        {
          id: 5,
          title: "第二十届广州国际汽车展览会媒体注册通知",
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_7/22_12.jpg",
          date: "2022-12-18",
          desc: "",
          detail: `<h2 class="media_font_size_70">第二十届广州国际汽车展览会媒体注册通知</h2><span class="detail_date">发布时间：2022-12-18</span><span class='detail_desc media_line_height_50 media_font_size_50'>各位媒体朋友：</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>第二十届广州国际汽车展览会媒体注册系统将于2022年12月19日开通，欢迎广大媒体记者登录广州汽车展官方网站或关注官方微信号“广州车展媒体之窗”在媒体通道进行注册。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>网上申请提交时间：2022年12月19日至12月27日下午18:00。</span>
<div class='detail_title media_line_height_50 media_font_size_50'>特别提醒：</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>1、线上及现场注册办理媒体证时，请您使用采访报道人员本人身份证及手机号进行注册，注册信息需如实详尽填写上传（基本资料、身份证件信息、手机号码、联系地址、记者证原件、相关证明材料等）。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2、本届车展的媒体证件将与媒体人员身份证信息绑定，入场时需刷身份证进行核验入场。现场可领取实体媒体证件，但此证件仅作为持证通道通过凭证，不作为最终入场凭证，仅持媒体证件但无身份证的人员将无法入场。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>3、媒体人员入场前请听从现场工作人员安排，在核实登记注册信息后，有序进入展馆。如届时您出示的身份证原件与本人不符，或与媒体证件注册信息不一致时，主办单位及展馆有权拒绝您进入展厅或展馆。</span>
<div class='detail_title media_line_height_50 media_font_size_50'>现场领取证件请出示以下材料：</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>1、个人领证应带资料</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>A.有效的身份证或护照原件。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>B.打印出的媒体注册回执。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>C.相关证明资料的原件（如记者证，电视台/电台官方证明、合法的出版公司/新闻媒体的委托函、具名的参展汽车企业邀请函等），复印件无效。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>(2) 团队领证应带资料</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>A.有效的身份证或护照原件。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>B.单位委托函原件（需加盖单位公章）。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>C.其余所有同事身份证复印件（需加盖单位公章）。</span>
<div class='detail_title media_line_height_50 media_font_size_50'>现场办理媒体证的注意事项：</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>1、只限本人办理，不得代为办理；</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2、现场办理媒体证人员需携带有效的个人身份证或护照原件及相关资料原件（如国家核发的媒体证，外交部签发的驻华媒体证，外国政府核发的媒体证，电视台/电台官方证明、合法的出版公司/新闻媒体的委托函、具名的参展汽车企业邀请函原件等），复印件均无效。</span>
<div class='detail_title media_line_height_50 media_font_size_50'>注意事项：</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>1、个人申请的媒体证件只限记者本人亲自领取，不得代领。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2、请认真填写预登记信息，主办单位审核之后，信息将不能修改。</span>
<div class='detail_title media_line_height_50 media_font_size_50'>官方网站：</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>www.autoguangzhou.com.cn</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>官方微信号：广州车展媒体之窗</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_4/2.jpeg' alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>再次感谢您对本届广州汽车展的关注与支持，祝您采访顺利！</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>第二十届广州国际汽车展览会组委会</span>`,
        },
        {
          id:14,
          title:'云中锦书之三 | 寄语广州国际车展二十周年',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_7/22_12.jpg",
          date:'2022-12-18',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/9.png' alt/>`
        },
        {
          id:15,
          title:'市商务局、市工信局领导出席广州国际车展新闻发布会',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_7/22_12.jpg",
          date:'2022-12-17',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/10.png' alt/>`
        },
        {
          id:16,
          title:'云中锦书之二 | 寄语广州国际车展二十周年',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_7/22_12.jpg",
          date:'2022-12-17',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/11.png' alt/>`
        },
        {
          id:17,
          title:'第二十届广州国际车展破局举办——共树行业新信心，携手走进新时代',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c4.jpg",
          date:'2022-12-16',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/12.png' alt/>`
        },
        {
          id:18,
          title:'云中锦书 ｜ 寄语广州国际车展二十周年',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_7/22_12.jpg",
          date:'2022-12-16',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/13.png' alt/>`
        },
        {
          id:19,
          title:'广州国际车展成为政府“抢机遇、拼经济、抓发展”的新动能',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c1.png",
          date:'2022-12-15',
          detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/14.png' alt/>`
        },
        //         {
        //           id: 1,
        //           img:
        //             "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/newscover.jpeg",
        //           title: "第十八届广州国际汽车展览会圆满闭幕",
        //           date: "2020-11-29",
        //           desc:
        //             "2020年11月29日，第十八届广州国际汽车展览会（下称“广州汽车展”）圆满落下帷幕。作为全世界唯一如期举办的国际A级车展，本届广州汽车...",
        //           detail: `<h2 class="media_font_size_70">广州车展闭幕</h2><span class="detail_date">发布时间：2020-11-29</span>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>2020年11月29日，第十八届广州国际汽车展览会（下称“广州汽车展”）圆满落下帷幕。作为全世界唯一如期举办的国际A级车展，本届广州汽车展在国内外汽车厂商的倾情参与下，在社会各界的大力支持下取得了圆满成功。历时十天的展会共吸引到观众76.2万人次。</span>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>广州地处“粤港澳”大湾区核心，辐射珠三角，经济发达，消费力强；广州也是全国最重要的汽车产业基地之一，产业链完整、集群效应突出。集区位、产业和市场优势于一身的广州汽车展，自2003年创办以来，一直是汽车行业的焦点之一，被誉为“中国汽车市场发展风向标”。十八年来，广州汽车展见证了中国汽车市场最为蓬勃的历史阶段，并与全球汽车行业携手步入转型升级的新时代。本届广州汽车展秉承“新科技、新生活”的主题，向行业传递新理念，向市场展示新模式，为汽车加持新科技，为大众打造新生活。</span>
        // <img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_1/20201129-1.png' alt/>
        // <div class='detail_title media_line_height_50 media_font_size_50'>媒体日重磅新车密集发布</div>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>本届广州汽车展共使用广交会展馆A区全部13个展厅及B区3个展厅，以及A区南北广场室外展区，展会规模达22万平方米。本届广州汽车展上共有全球首发车38台，跨国公司首发车9台；概念车20台，其中国际品牌展出9台，国内品牌展出11台；展车总数达980台。国内外参展车企共展出新能源车142台，其中国外企业展车60台。媒体日当天共举行了71场新闻发布会，10146名记者参与报道了展会盛况，其中包括全球各大新闻机构的驻华记者。</span>
        // <div class='detail_title media_line_height_50 media_font_size_50'>新能源汽车百花齐放</div>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>发展新能源汽车，是我国由汽车大国迈向汽车强国的必由之路。近年来，我国新能源汽车产业发展迅速，成为引领世界汽车产业转型的重要力量。在此大背景下，国内外主流车企纷纷加快在新能源汽车领域的布局，积极参与到这场浪潮之中。本届广州车展上除了率先拥抱新能源汽车的新势力造车企业以外，跨国车企纷纷推出包括纯电动和混合动力在内的新能源汽车系列产品；中国品牌汽车企业在经过数年的市场历练、技术积累、产业升级后，也纷纷推出高端新能源汽车品牌。众多豪华品牌、合资品牌也蓄势待发。新能源汽车百花齐放的背后，是行业格局的重塑，是企业竞争的愈加激烈，创新驱动的转型升级对企业提出了更高、更快的要求。
        // </span>
        // <div class='detail_title media_line_height_50 media_font_size_50'>智能网联技术大放异彩</div>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>随着以智能化为特征的第四次工业革命的深入推进，汽车智能网联化已然从概念进入到了全面应用的阶段，智能网联技术在向用户端和生产端双向同步发展。透过本届广州车展可以看到，在用户端，以智能芯片为核心的智能座舱已经由原来的电动车产品蔓延至传统汽车产品；车规级芯片结合激光雷达和百万像素级别高清摄像头组成的汽车视觉系统，让车辆自动驾驶在部分场景中成为现实；在新一代移动通信技术的加持下，车辆远程升级和V2X实时通信交互成为标配。在生产端，各大参展商展示了自己最先进的智能化研发生产制造平台。在本届广州汽车展上，中外企业围绕电动化、智能化、网联化的发展方向争相展出前沿技术成果和最新解决方案，为百年汽车工业注入了新活力。</span>
        // <div class='detail_title media_line_height_50 media_font_size_50'>消费升级需求势不可挡</div>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>“十九大”报告指出，在新时代，中国人民对美好生活的需求日益增长，最为直接的表现就是消费升级。今年虽受疫情影响，但广州车展上展现出的消费者对私家车出行的需求不降反增，展馆络绎不绝的人流，各展台上不断升级换代的汽车展品，展台上花样繁多的交互体验项目，均体现出升级汽车消费的需求势不可挡。需求端的消费潜力，正在有效转化为供给侧的增长动能，消费升级需求已经成为引领汽车市场持续回暖的重要力量。</span>
        // <img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_1/20201129-2.png' alt/>
        // <div class='detail_title media_line_height_50 media_font_size_50'>车生活成为市场关注新热点</div>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>科技以人为本，在本届广州汽车展上，车生活成为一个关注热点。人脸识别、车载无线充电、自动泊车辅助、L3级别自动驾驶等为车主在日常生活中提供便利性的人性化技术备受关注，深受车主的喜爱。在展馆外围，充满科技感的共享出行服务公司“如祺出行”为现场观众提供免费摆渡和观展接送服务，以体验式的全新方式，向业界展示了关于出行方式的车生活新选择。以家庭车为代表的车生活产品同样受到了大众的追捧，大家争相上车体验，畅享车生活新感受。</span>
        // <div class='detail_title media_line_height_50 media_font_size_50'>商用车展转型升级见成效</div>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>在2020年这个特殊的年份，我国商用车企业在疫情的不利影响下，顶住压力，充分利用新科技，通过线上营销、智慧服务等一系列应急方案，迅速重启了暂停的市场，实现了触底反弹，交出了一份亮眼的成绩单。在广州国际商用车展览会上，主流商用车企业悉数参展，并在媒体日举办了多场新闻发布会，向业界发布新产品、新技术、新理念、新模式。产业链上下游企业同样热情高涨，积极参与。</span>
        // <img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_1/20201129-3.png' alt/>
        // <div class='detail_title media_line_height_50 media_font_size_50'>零部件及用品题材丰富</div>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>广州汽车展顺应行业趋势，贴合市场需求，在原“广州国际汽车零部件及用品展览会”的基础上打造“广州国际改装车展览会”。在汽车零部件参展商方面，由原来针对主机厂和渠道商的通用件生产企业，转向针对车主端的个性化升级改装产品生产企业；在汽车用品参展商方面，由原来面向经销商的标准化产品生产企业，转向面对用户的创意型产品生产企业。同时扩大展品覆盖面，将汽车文化周边产品纳入展览展示范围，为车主提供更加丰富的有车以后用车玩车新选择。</span>
        // <div class='detail_title media_line_height_50 media_font_size_50'>高峰论坛聚集行业热点</div>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>媒体日当天，由中国国际贸易促进委员会汽车行业分会主办，以“共融共生、科创未来”为主题的“广州国际车展高峰论坛”在现场举办。论坛汇聚政府部门领导、汽车厂商代表、科技互联网领域精英和行业机构专家，共同探讨新形势下，中国汽车市场智能化、数字化、网联化等科技融合发展新趋势。</span>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>专业观众日，由广州国际商用车展组委会主办，以“融通新境界、智取新高度”为主题的“中国商用车新生态高峰论坛”在广州举办。会议现场，来自行业协会、研究院、汽车企业、科技公司、物流运输及车联网平台的精英代表汇聚一堂，共话新生态下的商用车发展之道。
        // </span>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>同样在专业观众日，由广州国际改装车展组委会、超级无敌汽车人新媒体联合发起的“广州国际汽车改装及设计沙龙”在展会现场举办。活动现场，来自汽车企业、研究院、官方改装品牌、设计工作室、汽车后市场企业等多方代表，同台交流汽车主流市场的本土化新趋势。</span>
        // <div class='detail_title media_line_height_50 media_font_size_50'>细致入微的疫情防控机制</div>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>本届广州汽车展是在疫情防控常态化状态下举办，在政府相关管理部门的指导和要求下，主、承办单位制定了完善的疫情防控方案和应急预案，实行了由主办方、展馆方、服务商、参展商共同参与的联防联控责任机制，严格执行实名制登记入场，切实做到“身份必录、信息必验、体温必测、口罩必戴、消毒必做、突发必处”。同时，展会现场还配备了紧急隔离区、医疗室、医疗救护车及专业医疗工作人员；展馆实行定期消杀制度，定期广播提醒观众佩戴口罩；展厅内安排网格化布控防疫监管人员，各展台配置了专职的防疫人员，落实展台的防疫责任，全方位、无死角地落实疫情防控工作，为展商及观众提供安全可靠的参展和观展环境。
        // </span>
        // <img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_1/20201129-4.png' alt/>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>第十八届广州汽车展的成功举办，有着极其特殊的意义。2020年初，新冠疫情突如其来，全球汽车产业按下了暂停键。而中国的汽车行业，在党和国家的领导下，坚持在常态化防控中统筹有序推进复工复产，并充分发挥国内超大规模市场优势，逐步形成以国内大循环为主体、国内国际双循环相互促进的新发展格局，在变局中不断开拓新局面。于是，中国成为了全球汽车市场中率先恢复的汽车市场，而广州汽车展的成功举办，有力地体现了中国汽车市场强大的韧性和蓬勃的生命力，为中国乃至全球汽车产业的复苏传递了坚定的信心。
        // </span>
        // <span class='detail_desc media_line_height_50 media_font_size_50'>第十九届广州国际汽车展览会将于2021年11月19日至28日（11月19日为媒体日）在中国进出口商品交易会展馆举办，我们期待与业界携手共进，开创新时代，共创新辉煌。</span>`,
        //         },
        {
          id: 4,
          title: "第十九届广州国际汽车展览会媒体注册通知",
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_4/3.png",
          date: "2021-11-1",
          desc: "",
          detail: `<h2 class="media_font_size_70">第十九届广州国际汽车展览会媒体注册通知</h2><span class="detail_date">发布时间：2021-11-01</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>各位媒体朋友：</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>第十九届广州国际汽车展览会媒体注册系统将于即日起开通，欢迎广大媒体记者登录广州汽车展官方网站或关注官方微信号“广州车展媒体之窗”在媒体通道进行注册。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>网上申请提交时间：2021年11月1日至2021年11月16日上午12:00。</span>
<div class='detail_title media_line_height_50 media_font_size_50'>特别提醒：</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>1）根据上级有关部门关于展览期间疫情防控要求，现对所有参与本届车展采访报道的媒体人员实行严格的实名信息线上登记注册或实名信息现场注册。线上及现场注册办理媒体证时，请您使用采访报道人员本人身份证及手机号进行注册，注册信息需如实详尽填写上传（基本资料、身份证件信息、手机号码、联系地址、记者证原件、相关证明材料等）。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2）本届车展的媒体证件将与媒体人员身份证信息绑定，审核通过的媒体记者需凭媒体注册审批通过回执及身份证，核验身份后刷身份证原件入场。现场可领取实体媒体证件，但此证件仅作为持证通道通过凭证，不作为最终入场凭证，仅持媒体证件但无身份证的人员将无法入场。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2）本届车展的媒体证件将与媒体人员身份证信息绑定，审核通过的媒体记者需凭媒体注册审批通过回执及身份证，核验身份后刷身份证原件入场。现场可领取实体媒体证件，但此证件仅作为持证通道通过凭证，不作为最终入场凭证，仅持媒体证件但无身份证的人员将无法入场。</span>
<div class='detail_title media_line_height_50 media_font_size_50'>本届展会媒体证件的使用方法：</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>媒体日（2021年11月19日），均可凭本人身份证进入展会。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>展期（2021年11月19日-11月28日）期间，可任意选择两天，凭本人身份证进入展会。</span>
<div class='detail_title media_line_height_50 media_font_size_50'>现场领取证件请出示以下材料：</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>(1)个人领证应带资料</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>A.有效的身份证或护照原件。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>B.打印出的媒体注册回执。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>C.相关证明资料的原件（如记者证，电视台/电台官方证明、合法的出版公司/新闻媒体的委托函、具名的参展汽车企业邀请函等），复印件无效。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>(2) 团队领证应带资料</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>A.有效的身份证或护照原件。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>B.单位委托函原件（需加盖单位公章）。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>C.其余所有同事身份证复印件（需加盖单位公章）。</span>
<div class='detail_title media_line_height_50 media_font_size_50'>领取实体证件及现场办理的时间和地点：</div>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_4/1.jpeg' alt/>
<div class='detail_title media_line_height_50 media_font_size_50'>现场办理媒体证的注意事项：</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>1、只限本人办理，不得代为办理；</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2、现场办理媒体证人员需携带有效的个人身份证或护照原件及相关资料原件（如国家核发的媒体证，外交部签发的驻华媒体证，外国政府核发的媒体证，电视台/电台官方证明、合法的出版公司/新闻媒体的委托函、具名的参展汽车企业邀请函原件等），复印件均无效。</span>
<div class='detail_title media_line_height_50 media_font_size_50'>注意事项：</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>1、个人申请的媒体证件只限记者本人亲自领取，不得代领。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2、请认真填写预登记信息，主办单位审核之后，信息将不能修改。</span>
<div class='detail_title media_line_height_50 media_font_size_50'>官方网站：</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>www.autoguangzhou.com.cn</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>官方微信号：广州车展媒体之窗</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_4/2.jpeg' alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>再次感谢您对本届广州汽车展的关注与支持，祝您采访顺利！</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>第十九届广州国际汽车展览会组委会</span>`,
        },
        {
          id: 2,
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_3/1.jpg",
          title: "科大讯飞将参展2021广州国际车展",
          date: "2021-8-29",
          desc: "",
          detail: `<h2 class="media_font_size_70">科大讯飞将参展2021广州国际车展</h2><span class="detail_date">发布时间：2021-8-29</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2008年，科大讯飞公司在深圳证券交易所挂牌上市（股票代码：002230），AI第一股，百亿营收，千亿市值，13亿利润，作为在汽车交互领域深耕十余年的企业，全套、全链路智能驾舱交互解决方案持续引流汽车行业将携重磅产品亮相 AUTO GUANGZHOU 2021广州国际车展。</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_3/1.jpg' alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>参展企业：科大讯飞股份有限公司(IFLYTEK CO.,LTD.)</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>科大讯飞智能汽车凭借“飞鱼OS MATE 2021”、“飞鱼智能助理MM 2021”、“飞鱼智云1.0”三大核心车联网系统解决方案</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_3/2.jpg' alt/>
<div class='detail_title media_line_height_50 media_font_size_50'>飞鱼OS MATE 2021—知你所想，懂你所需</div>
<span class='detail_desc media_line_height_50 media_font_size_50'> 飞鱼OS MATE 2021”的核心价值就是围绕让“汽车贴近用户，让用户对话汽车”的理念，依靠大数据算法与知识图谱，融合语音、视觉、音效、氛围灯等多模态交互手段，为用户提供场景化、个性化、情感化的服务。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>飞鱼OSMATE2021能够通过大数据分析，感知车主所处驾驶环境，为驾驶者提供相应的驾控建议，并为驾驶者提供音乐、新闻、电台等在线应用服务，甚至可以根据驾驶场景而提供相应的特定应用推荐；探索地图、种草地图功能，能推荐并记录车主感兴趣的美景、景点，在导航应用中，还可以语音直接添加目的地，让系统根据车主的行程在手机端、车机端安排提醒。此外，依托知识图谱能力，飞鱼OSMATE2021还会推荐车主个性化学习、了解爱车，并根据车主用车、养车、维修等车辆使用生命周期，来合理安排车主的用车问题。</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_3/3.jpg' alt/>
<div class='detail_title media_line_height_50 media_font_size_50'>飞鱼助理已覆盖多语种+方言语料</div>
<span class='detail_desc media_line_height_50 media_font_size_50'> 飞鱼智能助理MM 2021（后文简称飞鱼助理）是科大讯飞面向汽车前端市场的智能交互产品，此次发布的MM 2021版，代表着Multi—Modal（多模态交互），该产品面向汽车场景构建了“听说看显”一站式的技术链。</span>
<div class='detail_title media_line_height_50 media_font_size_50'>飞鱼智云1.0—汽车全链路服务的数智化平台解决方案</div>
<span class='detail_desc media_line_height_50 media_font_size_50'> 飞鱼智云至今已发展了10年，不仅引用了新技术，如云原生、微服务等，同时也自研了一套大数据、知识图谱等核心平台，进而支撑车联网产品和服务持续的创新。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'> 飞鱼智云1.0其主要包含了大数据、AI和业务中台，以及智能化云应用如场景立方、汽车知识大脑、用户画像等。</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_3/4.jpg' alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'> 科大讯飞在汽车智能化领域的第18个年头，也是科大讯飞智能汽车进入汽车前装市场的第10个年头，从一开始的结束中国汽车语音由外国公司垄断的历史，到中国每10辆装配智能语音交互的汽车有6辆使用了讯飞技术，再到此次推出的全套、全链路智能驾舱交互解决方案，科大讯飞一直在进步。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'> 目前，车内智能交互已经成为了众多车厂和科技互联网公司的必争之地，也逐渐成为了新上市车型的标配。如何带来更完善、更深入的驾舱交互体验，探索“语音+”时代的更多可能性，成为摆在众多入局者面前的问题。未来，科大讯飞将继续在核心技术上寻求创新突破、实现弯道超车。2021广州国际汽车展未来汽车科技展区会给大会一份满意的答卷，11月19日广州琶洲见。</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_3/5.jpg' alt/>
`,
        },
        {
          id: 3,
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_2/1.jpg",
          title: "AutoX将携无人驾驶硬核实力技术参加2021广州国际汽车展",
          date: "2021-9-7",
          detail: `<h2 class="media_font_size_70">AutoX将携无人驾驶硬核实力技术参加2021广州国际汽车展</h2><span class="detail_date">发布时间：2021-9-7</span>
<div class='detail_title media_line_height_50 media_font_size_50'>AutoX将携无人驾驶硬核实力技术参加2021广州国际汽车展</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>AutoX是中国L4级无人驾驶RoboTaxi的领跑者， 是目前国内唯一一家能够真正做到完全无人驾驶 RoboTaxi 试运营的公司，也是全球唯二面向公众，并且实现真正全无人的 RoboTaxi 试运营公司。AutoX已经在上海、深圳、武汉和其他许多城市部署了数以百计的RoboTaxi，也是全球首个城中村全无人驾驶测试公司。2021年11月19日AutoX将携硬核实力技术亮相 AUTO GUANGZHOU 2021广州国际车展。</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_2/1.jpg' alt/>
<div class='detail_title media_line_height_50 media_font_size_50'>01参展企业：深圳裹动智驾科技有限公司</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>AutoX是一家无人驾驶技术平台公司，创立于2016年9月，总部坐落深圳，在北京、上海、硅谷、圣地亚哥等共计全球8座城市有研发中心。AutoX RoboTaxi无人驾驶车辆在全球多个城市部署，规模化自动驾驶车队覆盖深圳、上海、美国硅谷等一线城市，具有全球13个城市自动驾驶经验与海量数据。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>AutoX公司的研发初衷是打造“平民化无人驾驶”打造最安全最有经验的人工智能司机AutoX Driver。首个获得加州自动驾驶测试牌照的中国初创自动驾驶公司。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2018年，AutoX获得广东省首张自动驾驶牌照；</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2019年5月获广州首发第一批自动驾驶路测牌照；</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2019年底，上海颁布自动驾驶新规2.0并发布首个升级版牌照，AutoX收入囊中；</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2020年起，AutoX在中国一线城市公开道路上展开了整车无安全员、无远程遥控的无人驾驶，积累了大量常态化、规模化全无人测试经验。</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_2/2.jpg' alt/>
<div class='detail_title media_line_height_50 media_font_size_50'>02平民化自动驾驶</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>打造一个比人类司机更安全的自动驾驶系统，让普通人都能享受出行交通的便捷。</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_2/3.jpg' alt/>
<div class='detail_title media_line_height_50 media_font_size_50'>03比人驾驶更安全</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>自动驾驶的AI司机不会疲劳，不会分神，也不会产生治安问题。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>通过采纳多种传感器，实现了比人类视觉更精准的感知与预知能力，达到超越人类司机的驾驶性能。</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_2/4.jpg' alt/>
<div class='detail_title media_line_height_50 media_font_size_50'>04技术造福大众</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>无人驾驶将大大降低交通的成本,从而为更多的人的出行提供便利。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>自动驾驶汽车还将在我们的日常通勤中释放我们的时间，而共享出行将通过释放停车场和车库来让我们的城市和生活更健康。</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_2/5.jpg' alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>近日，AutoX安途公开了最新夜间全无人驾驶视频，基于FCA克莱斯勒大捷龙的AutoX第五代无人车完成了在晚高峰嘈杂熙攘的深圳城中村道路上整车360度完全无人驾驶。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>视频显示，AutoX无人车在行驶过程中多次遇到了复杂场景。如在单车道宽度的狭窄道路上，AutoX无人车与对向车辆“狭路相逢”，AutoX无人车判断距离出口更近，通过向前挪动等信号表达前进意图，获得了路权；当双方车辆距离狭路出口都很远，AutoX无人车连续两次倒车，腾出足够空间，两台车互相绕行，帮助对方成功通过。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>据了解，本次发布的视频采用的是AutoX最新的第五代系统Gen5，配备了全球最顶级的车规级硬件和电子电气架构，共50个高清车规级传感器，包括28个8百万像素的车规级摄像头，每帧像素总和超过2.2亿；全球最高分辨率的4D毫米波雷达，角分辨率达到0.9度；高清激光雷达，每秒超1500万点云成像。</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_2/6.jpg' alt/>
<div class='detail_title media_line_height_50 media_font_size_50'>05回顾AutoX</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>2017年AutoX第一代无人驾驶方案</span>
<span class='detail_desc media_line_height_50 media_font_size_50'> 硬件：360°摄像头</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>性能：特斯拉FSD与华为Hi等价辅助驾驶能力</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2018年AutoX第二代无人驾驶方案</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>硬件：360°摄像头+激光雷达</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>性能：初步商业化试运营、外卖生鲜配送</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2019年AutoX第三代无人驾驶方案</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>硬件：360°摄像头+激光雷达+毫米波雷达</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>性能：中国繁华闹市区路况处理，雨雾天气处理</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2020年AutoX第四代无人驾驶方案</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>硬件：全套传感器+XCU域控制器</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>性能：车规级，面向量产</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2021年AutoX第五代无人驾驶方案（2021年）</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>硬件：高清传感器+车规级电子电气架构</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>性能：车内全无人、真正的全无人驾驶</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_2/7.jpg' alt/>
<div class='detail_title media_line_height_50 media_font_size_50'>06在无人驾驶安全领域，AutoX极为重视及投入：</div>
<span class='detail_desc media_line_height_50 media_font_size_50'>1、通过与国际车企深度合作，将首台经过大规模无人驾驶验证的车辆引入中国。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>2、通过自主研发中国首款L4无人驾驶级别域控制器AutoX XCU，实现车规级别功能安全的多重冗余，以及多传感器的硬件同步，真正实现软硬件一体化设计。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'>3、通过强大的AI，对付都市城区繁华道路的各种突发现象，同时避免远程遥控带来的交通和网络安全风险。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'> 4、通过完善的高分辨率感知系统，实现对所有物体的精确感知，对复杂大都市路况的道路使用者的安全负责任。</span>
<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_2/8.jpg' alt/>
<span class='detail_desc media_line_height_50 media_font_size_50'>   如今进入自动驾驶赛道上的企业众多，有实力做无人驾驶的企业却寥寥无几，据自动驾驶行业内专业人士介绍，整车企业的自动驾驶路线均是辅助驾驶，“100%专注做无人驾驶的公司目前在中国就只有两家而已。”“滴滴和AutoX是全部All in在无人驾驶上的。</span>
<span class='detail_desc media_line_height_50 media_font_size_50'> 未来AutoX 将如何发挥这张全自动驾驶载人牌照，迈入下个阶段，我们不妨拭目以待！！2021年11月19日广州国际汽车展未来汽车科技展区见！</span>
`,
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.query.tab != from.query.tab) {
        this.changeTabs(to.query.tab);
      }
    },
  },
  methods: {
    changeTabs(index) {
      let that = this;
      that.activeIndex = index;
      if (that.curs) {
        that.curIndex = that.curs;
        that.detailFlag = true;
        that.showList = false;
        that.$router.replace({
          query: merge(
            {},
            {
              tab: that.activeIndex,
              cur: that.curs,
            }
          ),
        });
      }
      // console.log(this.newsId);
      if (this.newsId) {
        this.newsList.map((item, index) => {
          if (this.newsId == item.id) {
            console.log(index);
            that.checkDetail(index);
            return;
          }
        });
      } else if (this.noticeId) {
        this.noticeList.map((item, index) => {
          if (this.noticeId == item.id) {
            // console.log(index);
            that.checkDetail(index);
            return;
          }
        });
      }
    },
    _getList(){

    },
    checkDetail(index) {
      this.curIndex = index;
      this.detailFlag = true;
      this.showList = false;
      this.$router.replace({
        query: merge(
          {},
          {
            tab: this.activeIndex,
            cur: this.curIndex,
          }
        ),
      });
    },
    changeTab(index) {
      this.activeIndex = index;
      this.detailFlag = false;
      this.showList = true;
      // console.log(this.activeIndex, this.showList);
    },
  },
};
</script>

<style lang="scss">
.news-container {
  width: 100vw;
  background: #221f26;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  cursor: default;
  min-height: 100vh;
  justify-content: space-between;

  .content_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .son-page {
    width: 1920px;
    height: 300px;
    background-image: url("https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner_6.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .menu_wrap {
    width: 1200px;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 60px;

    .news_wrap {
      height: 100px;
      border-bottom: 1px solid rgba($color: #fff, $alpha: 0.2);
      box-sizing: border-box;
      display: flex;

      > div {
        font-size: 30px;
        // width: 143px;
        line-height: 100px;
        text-align: center;
        color: #ccc;
        border-bottom: 2px solid transparent;
        margin-right: 50px;
      }

      .act-item {
        color: #42abff;
        border-bottom: 1px solid #42abff;
      }
    }

    .right_wrap {
      display: flex;
      color: rgba(255, 255, 255, 0.8);
      align-items: center;
    }
  }

  .news_list_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;

    .news_list_wrap {
      width: 100%;
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;

      .news_item_card {
        display: flex;
        flex-direction: column;
        margin-bottom: 89px;
        width: 370px;

        // margin-right: 50px;
        .news_img {
          width: 370px;
          height: 260px;
          margin-bottom: 26px;
          position: relative;

          > img {
            width: 370px;
            height: 260px;
          }

          > div {
            visibility: hidden;
            position: absolute;
            width: 100%;
            height: 260px;
            background: rgba($color: #000000, $alpha: 0.5);
            display: flex;
            flex-direction: column;
            justify-content: center;

            > i {
              color: #fff;
              font-size: 50px;
              margin: 0 auto;
            }
          }
        }

        .news_img:hover {
          > div {
            visibility: visible;
          }
        }

        > h2 {
          width: 352px;
          // height: 22px;
          line-height: 40px;
          font-size: 22px;
          color: #ffffff;
          margin: 0;
        }

        .news_desc {
          width: 358px;
          max-height: 120px;
          font-size: 20px;
          color: #cccccc;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          line-height: 40px;
        }

        > span {
          // width: 81px;
          // height: 12px;
          line-height: 60px;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }

    .news_list_box_item {
      .img_mask {
        position: relative;

        > div {
          visibility: hidden;
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba($color: #000000, $alpha: 0.5);
          display: flex;
          flex-direction: column;
          justify-content: center;

          > i {
            color: #fff;
            font-size: 50px;
            margin: 0 auto;
          }
        }
      }

      .img_mask:hover {
        > div {
          visibility: visible;
        }
      }
    }
  }

  .news_notice {
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;

    .notice_list_wrap {
      // width: 1200px;
      width: 100%;
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;

      .notice_item_card {
        display: flex;
        flex-direction: column;
        margin-bottom: 89px;
        width: 470px;
        margin-right: 50px;

        .notice_img {
          width: 470px;
          height: 260px;
          margin-bottom: 26px;
          position: relative;

          > img {
            width: 470px;
            height: 260px;
          }

          > div {
            visibility: hidden;
            position: absolute;
            width: 470px;
            height: 260px;
            background: rgba($color: #000000, $alpha: 0.5);
            display: flex;
            flex-direction: column;
            justify-content: center;

            > i {
              color: #fff;
              font-size: 50px;
              margin: 0 auto;
            }
          }
        }

        .notice_img:hover {
          > div {
            visibility: visible;
          }
        }

        > h2 {
          width: 352px;
          // height: 22px;
          line-height: 40px;
          font-size: 22px;
          color: #ffffff;
          margin: 0;
        }

        .notice_desc {
          width: 358px;
          max-height: 120px;
          font-size: 20px;
          color: #cccccc;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          line-height: 40px;
        }

        > span {
          // width: 81px;
          // height: 12px;
          line-height: 50px;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }

    .news_list_box_item {
      .img_mask {
        position: relative;

        > div {
          visibility: hidden;
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba($color: #000000, $alpha: 0.5);
          display: flex;
          flex-direction: column;
          justify-content: center;

          > i {
            color: #fff;
            font-size: 50px;
            margin: 0 auto;
          }
        }
      }

      .img_mask:hover {
        > div {
          visibility: visible;
        }
      }
    }
  }

  .detail_wrap {
    margin: 100px 0px;

    > div {
      display: flex;
      flex-direction: column;

      > h2 {
        text-align: center;
        color: #fff;
        font-size: 30px;
      }

      .detail_date {
        text-align: center;
        color: #ccc;
        margin-bottom: 56px;
        font-size: 20px;
        margin: 20px;
      }

      .detail_title {
        color: #42abff;
        font-size: 20px;
        margin-bottom: 53px;
      }

      .detail_desc {
        font-size: 20px;
        color: #ccc;
        text-indent: 50px;
        margin-bottom: 40px;
      }

      .text_right {
        text-align: right;
      }

      > img {
        margin: 50px 0px;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .news-container {
    .menu_wrap {
      width: 100vw;
      height: 200px;
      justify-content: center;

      .news_wrap {
        // width: 100%;
      }

      .right_wrap {
        display: none;
      }
    }

    .news_list_box {
      display: flex;
      flex-direction: column;
      align-items: center;

      .news_list_wrap {
        width: 100vw;
        padding: 0px 50px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .news_item_card {
          display: flex;
          flex-direction: column;
          margin-bottom: 89px;
          width: 46vw;

          .news_img {
            width: 100%;
            height: 520px;
            margin-bottom: 26px;
            position: relative;

            > img {
              width: 100%;
              height: 520px;
            }
          }

          > h2 {
            width: 100%;
            // height: 22px;
            font-size: 22px;
            color: #ffffff;
            line-height: 120px;
            // margin: 0;
          }

          .news_desc {
            width: 100%;
            max-height: 120px;
            font-size: 20px;
            color: #cccccc;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            line-height: 120px;
          }

          > span {
            font-size: 16px;
            color: #ffffff;
            line-height: 120px;
          }
        }
      }
    }

    .news_notice {
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;

      .notice_list_wrap {
        width: 100vw;
        padding: 0px 50px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .notice_item_card {
          display: flex;
          flex-direction: column;
          margin-bottom: 89px;
          width: 46vw;

          .notice_img {
            width: 100%;
            height: 520px;
            margin-bottom: 26px;
            position: relative;

            > img {
              width: 100%;
              height: 520px;
            }

            > div {
              visibility: hidden;
              position: absolute;
              width: 470px;
              height: 260px;
              background: rgba($color: #000000, $alpha: 0.5);
              display: flex;
              flex-direction: column;
              justify-content: center;

              > i {
                color: #fff;
                font-size: 50px;
                margin: 0 auto;
              }
            }
          }

          .notice_img:hover {
            > div {
              visibility: visible;
            }
          }

          > h2 {
            width: 100%;
            // height: 22px;
            line-height: 120px;
            font-size: 22px;
            color: #ffffff;
            margin: 0;
          }

          .notice_desc {
            width: 358px;
            max-height: 120px;
            font-size: 20px;
            color: #cccccc;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            line-height: 40px;
          }

          > span {
            // width: 81px;
            // height: 12px;
            line-height: 120px;
            font-size: 16px;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>

<style>
.news-container .el-breadcrumb__item .el-breadcrumb__inner {
  color: rgba(255, 255, 255, 0.8) !important;
}

.text-in {
  text-indent: 2em;
}

.bold {
  font-weight: bold;
}

.lh-60 {
  line-height: 100px !important;
}

.download {
  text-decoration: underline;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// index.vue?706a1994